import { render } from "./HomePlaceholderElement.vue?vue&type=template&id=44ab598c&scoped=true"
import script from "./HomePlaceholderElement.vue?vue&type=script&lang=js"
export * from "./HomePlaceholderElement.vue?vue&type=script&lang=js"

import "./HomePlaceholderElement.vue?vue&type=style&index=0&id=44ab598c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44ab598c"]])

export default __exports__